import axios from "axios";
import { loadTokenSync, saveToken, clearToken } from "./tokenStore";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = loadTokenSync();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Sliding session refresh — backend returns a fresh JWT when the current
    // one is close to expiring. Persist to BOTH storage backends so an iOS
    // PWA eviction of localStorage doesn't kill the session.
    const refreshed = r.headers?.["x-refreshed-token"];
    if (refreshed) {
      saveToken(refreshed);
    }
    // Backend version broadcast (read by VersionWatcher).
    const version = r.headers?.["x-app-version"];
    if (version) {
      try {
        const known = localStorage.getItem("hosys_backend_version");
        if (!known) {
          localStorage.setItem("hosys_backend_version", version);
        } else if (known !== version) {
          window.dispatchEvent(new CustomEvent("hosys:new-version", {
            detail: { old: known, current: version },
          }));
        }
      } catch { /* ignore */ }
    }
    return r;
  },
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register") && path !== "/") {
        clearToken();
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
